import { Badge } from '@chakra-ui/react';

const VBadge = ({ children, ...props }) => <Badge {...props}>{children}</Badge>;

export default VBadge;
